import React, { useEffect } from "react"
import { connect } from "react-redux";
import * as layoutService from "../view/layoutService";
import { withMainLayout } from "../view/LayoutHOCs";
import { useHistory } from "react-router-dom";
import ChartSection from "./ChartsSection";
import { InfoBoxes } from "../info-boxes/InfoBoxes";

const breadcrumbs = [
    {
        text: "Home",
        redirectTo: "/",
        iconClassName: "icon-home"
    },
    {
        text: "System Status",
        redirectTo: "/system",
    }
]

function SystemStatus({ userCapability }) {

    const history = useHistory();

    useEffect(() => {
        layoutService.setPageTitle('System Status')
        layoutService.setBreadcrumbs(breadcrumbs)
    }, [history.location])

    //Hide pages with capability = -1, and even if the url is copied then logout the user directly
    //#region Set User Capabilities
    const checkCapability = async () => {
        try {
            if (userCapability) {
                const capability = userCapability.find(item =>
                    item.component === "systemstatus" && item.type === "page")?.permission;
                if (capability === -1) {
                    sessionStorage.removeItem('access_token');
                    window.location.reload();
                }
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };

    useEffect(() => {
        checkCapability();
        /* eslint-disable react-hooks/exhaustive-deps */
    }, []);
    //#endregion

    return (
        <div className="container-fluid system-status-page">
            <InfoBoxes />
            <ChartSection />
        </div>
    );
}


function mapStateToProps(state) {
    const auth = state.auth;
    return {
        userCapability: auth.userCapability,
    }
}

export default withMainLayout(connect(mapStateToProps)(SystemStatus));